import { Injectable } from '@angular/core';
import { GrpcLibService, GrpcLibServiceOption } from '../grpc-lib.service';
import { UserLibService } from '../../user/user-lib.service';
import { StorageLibService } from '../../storage/storage-lib.service';
import { Empty, GolfClassLevel, RequestID } from '../../../libs/proto/commUnity_pb';
import { Observable } from 'rxjs';
import * as grpcWeb from 'grpc-web';
import { GolfClassLevelConversionService } from '../../conversion/golf_class/golfclasslevel-conversion.service';

@Injectable({
  providedIn: 'root'
})
export class GrpcGolfClassLevelLibService {

  constructor(
    private grpcLib: GrpcLibService,
    private userLib: UserLibService,
    private storLib: StorageLibService,
    private convLib: GolfClassLevelConversionService,
  ) { }

  getGolfClassLeveles(option?: GrpcLibServiceOption): Promise<GolfClassLevel[]>{
    return new Observable<GolfClassLevel[]>(obs => {
      const opt = this.grpcLib.getOption(option);
      opt.call.subscribe = obs;

      if (!this.grpcLib.Data.online || (opt.Offline || false)) {
        this._getGolfClassLevelesOffline(opt);
      } else {
        this._getGolfClassLevelesOnline(opt);
      }

    }).toPromise();
  }

  private _getGolfClassLevelesOffline(option: GrpcLibServiceOption){
    this.convLib.FromStorages(
      (this.storLib.get('g-classlv-s') || this.storLib.get('g-classlv')), (ns, e) => {
        if (e == null) {
          if ((option.call.req || '') !== ''){
            if (ns) {
              option.call.subscribe.next( ns.filter( n => {
                return n.getId() === option.call.req;
              }));
              option.call.subscribe.complete();
              return;
            }
          }
        }

        option.call.subscribe.next(ns || []);
        option.call.subscribe.complete();
    });
  }

  private _getGolfClassLevelesOnline(option: GrpcLibServiceOption){
    this.grpcLib.MobileClient.getGolfClassLevels(new Empty(), {
        token: this.userLib.Data.token?.getToken(),
      })
      .on('error', (e: grpcWeb.RpcError) => {
        this._getGolfClassLevelesOnlineError(e, option);
      })
      .on('status', (s: grpcWeb.Status) => {
        this._getGolfClassLevelesOnlineStatus(s, option);
      })
      .on('data', (r: GolfClassLevel) => {
        this._getGolfClassLevelesOnlineData(r, option);
      })
      .on('end', () => {
        this._getGolfClassLevelesOnlineEnd(option);
      });
  }

  private _getGolfClassLevelesOnlineData(ret: GolfClassLevel, option: GrpcLibServiceOption) {
    option.call.data.push(ret);
  }

  private _getGolfClassLevelesOnlineError(e: grpcWeb.RpcError, option: GrpcLibServiceOption) {
    const thise = this;

    this.grpcLib.handleError(e, () => {
      thise._getGolfClassLevelesOnline(option);
    }, option);
  }

  private _getGolfClassLevelesOnlineEnd(option: GrpcLibServiceOption) {
    option.call.subscribe.complete();
  }

  private _getGolfClassLevelesOnlineStatus(s: grpcWeb.Status, option: GrpcLibServiceOption) {
    if (s.code === 0) {
      this.storLib.cache.golfClassLevel = true;
      if (option.KeepInCache || false) {
        this.storLib.set(
          'g-classlv', this.convLib.ToStorages(option.call.data)
        );
      }

      option.call.subscribe.next(option.call.data);
      if (option?.callback) { option?.callback(option.call.data); }
    } else {
      this.grpcLib.treatStatus(s, () => {
        this._getGolfClassLevelesOnline(option);
      }, option);
    }
  }
}
